import React from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  Fade,
  Backdrop,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const ClaimOverlay = ({ open, onClose, rewardAmount, containerRef, onClaim, isClaiming }) => {
  const { t } = useTranslation();
  if (!open || !containerRef?.current) return null;

  return (
    <>
      {/* Backdrop only inside the calendar container */}
      <Backdrop
        open={open}
        sx={{
          zIndex: 10,
          position: "absolute",
          borderRadius: 3,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
        }}
        container={containerRef.current}
      />

      {/* Centered overlay inside calendar */}
      <Fade in={open}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            color: "white",
            p: 3,
            borderRadius: 3,
            outline: "none",
            zIndex: 11,
          }}
        >
          {/* 🎁 Glowing gift */}
          <Box
            component="img"
            src={process.env.REACT_APP_DAILY_MISSION_CLAIM_IMG}
            alt="Gift"
            sx={{ width: 300, cursor: "pointer" }}
            onClick={onClaim}
          />

          {rewardAmount ? (
            <>
              <Typography variant="h6" sx={{ mt: 2 }}>
                You have won
              </Typography>
              <Typography
                variant="h4"
                fontWeight="bold"
                color="gold"
                sx={{ my: 1 }}
              >
                {rewardAmount}
              </Typography>
              <Button
                variant="contained"
                sx={{ backgroundColor: "red", borderRadius: 2, px: 4 }}
                onClick={onClaim}
              >
                OKAY
              </Button>
            </>
          ) : (
            // <Typography variant="subtitle1" sx={{ mt: 2 }}>
            //   {t('mission.taptoclaimyourreward')}
            // </Typography>
            <Typography
              onClick={onClaim}
              variant="subtitle1"
              sx={{
                px: 2,
                py: 1,
                borderRadius: "16px",
                backgroundColor: "rgb(0, 0, 0, 0.4)",
                display: "inline-block",
                fontWeight: "bold",
                color: "white",
                textShadow: "0px 0px 8px rgba(255, 208, 0, 0.9)",
                cursor: "pointer",
                // animation: "pulse 1.5s infinite",
                // "@keyframes pulse": {
                //   "0%": { transform: "scale(1)", opacity: 1 },
                //   "50%": { transform: "scale(1.1)", opacity: 0.8 },
                //   "100%": { transform: "scale(1)", opacity: 1 },
                // },
                border: "2px solid #FFD000",
              }}
            >
              {t('mission.taptoclaimyourreward')}
            </Typography>
          )}

          {/* <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "white",
            }}
          >
            <CloseIcon />
          </IconButton> */}
        </Box>
      </Fade>
    </>
  );
};

export default ClaimOverlay;
